import {
  determineLanguage,
  determineLanguageRegion
} from '../localizationUtils';

export function getMarketSettings() {
  const languageCode = determineLanguage();
  const languageRegionCode = determineLanguageRegion(languageCode);

  return { languageCode, languageRegionCode };
}
